import Image from "next/image";
import Button from "@/atoms/Button";
import { PaginationProps } from "../types";
import { useEffect } from "react";

const Pagination = ({pageNumber, totalPages, setPageNumber}: PaginationProps): JSX.Element => {

  let pagesToShow = [];

  if (totalPages <= 4) {
    pagesToShow = Array.from({ length: totalPages }, (_, i) => i + 1);
  } else {
    if (pageNumber >= totalPages - 1) {
      pagesToShow = [totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else if (pageNumber <= 2) {
      pagesToShow = [1, 2, 3, '...', totalPages];
    }else {
      pagesToShow = [pageNumber - 1, pageNumber, pageNumber + 1, '...', totalPages];
    }
  }

  useEffect(() => {
    setPageNumber(1);
  }, [totalPages]);

  return (
    <>
      <div className="hidden md:flex w-full justify-center items-center my-10 gap-4 md:p-6">
        <div 
          onClick={() => setPageNumber(pageNumber - 1)}
          className={`cursor-pointer ${pageNumber === 1 ? 'opacity-40 pointer-events-none' : ''}`}
        >
          <Image
            src="/koach/left-arrow.svg"
            alt="left arrow"
            priority
            width={25}
            height={25}
            className="cursor-pointer"
            onClick={() => setPageNumber(pageNumber - 1)}
          />
        </div>
        
        <div className="flex items-center md:gap-1 font-semibold">
          {pagesToShow.map((page, index) => {
            return (
              <Button 
                key={index}
                variant="secondary" 
                className={`p-4 md:p-6 rounded-xl ${pageNumber === page ? 'bg-blue-100' : ''}`}
                onClick={() => setPageNumber(typeof page === 'number' ? page : pageNumber)}
              >
                {page}
              </Button>
            );
          })}
        </div>
        
        <div
          onClick={() => setPageNumber(pageNumber + 1)}
          className={`cursor-pointer ${pageNumber === totalPages ? 'opacity-40 pointer-events-none' : ''}`}
        >
          <Image
            src="/koach/right-arrow.svg"
            alt="right arrow"
            priority
            width={25}
            height={25}
            className="cursor-pointer"
            onClick={() => setPageNumber(pageNumber + 1)}
          />
        </div>
      </div>
    </>
  );
};

export default Pagination;
